import React, { Fragment, useEffect } from 'react';
import { Navbar, Nav } from 'react-bootstrap'
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchWorkshops } from '../redux/actions/productActions';
import MobileNav from './MobileNav';
import { find } from 'lodash';
import { NavLink } from 'react-router-dom';

const Header = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const workshops = useSelector(state => state.productData.workshops);

  useEffect(() => {
    if (!workshops || workshops.length === 0) {
      dispatch(fetchWorkshops());
    }
  }, [dispatch, workshops]);

  // const ftzCompetition = find(workshops, { _id: "FTZ Corporate Clash" });
  // const isFTZEnabled = ftzCompetition ? ftzCompetition.enable : false;
  const competitions = workshops ? workshops.filter(o => o.type && o.type.toLowerCase() === 'competition' && o.enable) : [];

  return (
    <Fragment>
      <Navbar expand="lg" sticky="top" id="Navbar">
        <Navbar.Brand href="https://www.projectrock.com.my">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
            className="img-fluid"
            alt=""
          />
        </Navbar.Brand>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto">
            {/* <Nav.Link className={`${pathname.includes('competition') ? 'active' : ''}`} href="/competition/vertex-2025">Vertex 2025</Nav.Link> */}
            {/* {isFTZEnabled && (
              <Nav.Link className={`${pathname.includes('competition') ? 'active' : ''}`} href="/competition/ftz-corporate-clash">FTZ Corporate Clash</Nav.Link>
            )} */}
            {competitions.map((comp) => {
              const slug = comp._id.replace(/\s+/g, '-').toLowerCase();
              return (
                <Nav.Link
                  as={NavLink}
                  key={comp._id}
                  to={`/competition/${slug}`}
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  {comp._id}
                </Nav.Link>
              );
            })}
            <Nav.Link as={NavLink} to="/workshop" className={({ isActive }) => (isActive ? 'active' : '')}>Workshops</Nav.Link>
            <Nav.Link href="https://www.projectrock.com.my">Project Rock Homepage</Nav.Link>
            <Nav.Link as={NavLink} to="/" end className={({ isActive }) => (isActive ? 'active' : '')}>Online Tickets</Nav.Link>
            <Nav.Link as={NavLink} to="/change_date" className={({ isActive }) => (isActive ? 'active' : '')}>Change Visit Date</Nav.Link>
            {/*<Nav.Link href="/renew_member">Membership Renewal</Nav.Link>*/}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      {/* <MobileNav isFTZEnabled={isFTZEnabled} pageWrapId={"Navbar"} outerContainerId={"App"} className="mobile-tablet" /> */}
      <MobileNav competitions={competitions} pageWrapId={"Navbar"} outerContainerId={"App"} className="mobile-tablet" />
    </Fragment>
  )
}

export default Header;